const BookingAddressMixin = {
  
};

module.exports = BookingAddressMixin;